import { RequestService } from '../../services/RequestService';
import { GET_VEHICLE_CATEGORIES } from '../constants';

export const getVehicleCategories = payload => {
  return RequestService.get(GET_VEHICLE_CATEGORIES);
};
